const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Streamlines around a cylinder ──────────────────────
function DiagramFlowLines() {
  const W = 680, H = 300;
  const cx = 340, cy = 150, r = 42;
  const streamlines = [
    { d:`M 60 58 C 180 58 260 50 295 60 C 320 68 330 84 ${cx-r} 104 C ${cx} 90 ${cx+r} 104 C 400 118 440 62 520 58 C 580 54 640 58 680 58`, color:'#2980b9', w:1.4 },
    { d:`M 60 100 C 180 100 250 92 282 103 C 308 112 320 122 ${cx-r} 132 C ${cx} 120 ${cx+r} 132 C 365 140 410 104 500 100 C 580 96 640 100 680 100`, color:'#2980b9', w:1.4 },
    { d:`M 60 200 C 180 200 250 208 282 197 C 308 188 320 178 ${cx-r} 168 C ${cx} 180 ${cx+r} 168 C 365 160 410 196 500 200 C 580 204 640 200 680 200`, color:'#2980b9', w:1.4 },
    { d:`M 60 242 C 180 242 260 250 295 240 C 320 232 330 216 ${cx-r} 196 C ${cx} 210 ${cx+r} 196 C 400 182 440 238 520 242 C 580 246 640 242 680 242`, color:'#2980b9', w:1.4 },
  ];
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Streamlines, Pathlines &amp; Streaklines — Flow Around a Cylinder</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrSL" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9" opacity="0.85"/>
          </marker>
          <marker id="arrSLR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
        </defs>

        {/* Flow direction */}
        <line x1="62" y1="26" x2="138" y2="26" stroke="#555" strokeWidth="1.2" markerEnd="url(#arrSL)"/>
        <text x="66" y="20" fontFamily="Georgia,serif" fontSize="11" fill="#555" fontStyle="italic">flow direction</text>

        {/* Streamlines */}
        {streamlines.map((sl, i) => (
          <path key={i} d={sl.d} fill="none" stroke={sl.color} strokeWidth={sl.w} opacity="0.65"/>
        ))}

        {/* Mid-stream arrows */}
        {[58,100,200,242].map(y => (
          <line key={y} x1="200" y1={y} x2="234" y2={y}
            stroke="#2980b9" strokeWidth="1.4" markerEnd="url(#arrSL)" opacity="0.8"/>
        ))}
        {[58,100,200,242].map(y => (
          <line key={`r${y}`} x1="470" y1={y} x2="504" y2={y}
            stroke="#2980b9" strokeWidth="1.4" markerEnd="url(#arrSL)" opacity="0.8"/>
        ))}

        {/* Cylinder */}
        <circle cx={cx} cy={cy} r={r} fill="#e8e0d0" stroke="#7B0D0D" strokeWidth="2"/>
        <text x={cx} y={cy+5} textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fill="#7B0D0D" fontWeight="700">cylinder</text>

        {/* Stagnation points */}
        <circle cx={cx-r} cy={cy} r="4" fill="#c0392b"/>
        <text x={cx-r-6} y={cy-8} textAnchor="end" fontFamily="Georgia,serif" fontSize="10" fill="#c0392b">stagnation</text>
        <circle cx={cx+r} cy={cy} r="4" fill="#c0392b"/>
        <text x={cx+r+6} y={cy-8} fontFamily="Georgia,serif" fontSize="10" fill="#c0392b">stagnation</text>

        {/* Pathline label */}
        <path d="M 60 150 C 200 150 270 146 297 150" fill="none"
          stroke="#c0392b" strokeWidth="1.8" strokeDasharray="6 3" opacity="0.8"/>
        <text x="62" y="144" fontFamily="Georgia,serif" fontSize="11" fill="#c0392b" fontStyle="italic">pathline ≡ streamline (steady flow)</text>

        {/* Convergence label */}
        <text x="cx" y="280" fontFamily="Georgia,serif" fontSize="11" fill="#888"
          textAnchor="middle"/>
        <text x="340" y="284" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11"
          fill="#555" fontStyle="italic">streamlines converge → velocity increases near the cylinder</text>

        {/* Legend */}
        <line x1="40" y1="270" x2="72" y2="270" stroke="#2980b9" strokeWidth="2"/>
        <text x="78" y="274" fontFamily="Georgia,serif" fontSize="11" fill="#2980b9">streamlines</text>
        <line x1="180" y1="270" x2="212" y2="270" stroke="#c0392b" strokeWidth="1.8" strokeDasharray="5 2"/>
        <text x="218" y="274" fontFamily="Georgia,serif" fontSize="11" fill="#c0392b">pathline / streakline (steady)</text>
      </svg>
      <div style={S.dCaption}>
        Streamlines are tangent to velocity at every point (instantaneous snapshot). Closely spaced lines near the cylinder indicate
        higher velocity. In steady flow, streamlines, pathlines, and streaklines all coincide — making dye or smoke visualisation
        directly equivalent to the streamline pattern. Streamlines can never cross one another.
      </div>
    </div>
  );
}

// ── Diagram 2: Eulerian vs Lagrangian ─────────────────────────────
function DiagramEulerLagrange() {
  const W = 680, H = 260;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Eulerian vs Lagrangian Description of Fluid Motion</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrEL" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrELR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
        </defs>

        {/* Eulerian panel */}
        <rect x="30" y="28" width="290" height="210" rx="8" fill="#EAF3FF" stroke="#2980b9" strokeWidth="1.2"/>
        <text x="175" y="52" textAnchor="middle" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#2980b9">Eulerian — fixed points</text>

        {[80,140,200,260].map(x =>
          [82,130,178].map(y => (
            <g key={`${x}-${y}`}>
              <circle cx={x} cy={y} r="3" fill="#2980b9" opacity="0.45"/>
              <line x1={x} y1={y} x2={x+16} y2={y-7}
                stroke="#2980b9" strokeWidth="1.2" markerEnd="url(#arrEL)" opacity="0.65"/>
            </g>
          ))
        )}

        {/* Sensor box */}
        <rect x="118" y="100" width="44" height="44" rx="4"
          fill="none" stroke="#c0392b" strokeWidth="1.4" strokeDasharray="5 2"/>
        <text x="140" y="130" textAnchor="middle" fontFamily="Georgia,serif" fontSize="9" fill="#c0392b">sensor</text>
        <text x="175" y="220" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555" fontStyle="italic">"What happens at this location?"</text>

        {/* Lagrangian panel */}
        <rect x="360" y="28" width="290" height="210" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.2"/>
        <text x="505" y="52" textAnchor="middle" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#7B0D0D">Lagrangian — fluid parcels</text>

        {[
          {d:"M 378 88 C 420 83 464 98 504 86 C 536 76 576 93 638 86"},
          {d:"M 378 138 C 420 143 464 128 504 140 C 536 150 576 136 638 140"},
          {d:"M 378 188 C 420 183 464 193 504 182 C 536 173 576 188 638 184"},
        ].map(({d}, i) => (
          <path key={i} d={d} fill="none" stroke="#c0392b" strokeWidth="1.2" strokeDasharray="4 2" opacity="0.55"/>
        ))}

        {[
          {cx:400,cy:87, l:'A₁'},{cx:464,cy:98, l:'A₂'},{cx:524,cy:86, l:'A₃'},
          {cx:412,cy:141,l:'B₁'},{cx:504,cy:140,l:'B₂'},{cx:592,cy:136,l:'B₃'},
        ].map(({cx,cy,l}) => (
          <g key={l}>
            <circle cx={cx} cy={cy} r="6" fill="#c0392b" opacity="0.72"/>
            <text x={cx} y={cy+14} textAnchor="middle" fontFamily="Courier New,monospace" fontSize="9" fill="#7B0D0D">{l}</text>
          </g>
        ))}

        <text x="505" y="220" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555" fontStyle="italic">"Follow this fluid parcel over time."</text>
      </svg>
      <div style={S.dCaption}>
        Eulerian (left): velocity, pressure, and other properties recorded at fixed grid points in space — like weather stations.
        Lagrangian (right): individual fluid parcels tagged and tracked — like GPS drifter buoys in the ocean.
        The material derivative D/Dt mathematically connects the two perspectives.
      </div>
    </div>
  );
}

// ── Diagram 3: Material Derivative ───────────────────────────────
function DiagramMaterialDerivative() {
  const W = 680, H = 252;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Material Derivative — Local &amp; Convective Acceleration</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrMD" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrMDB" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrMDG" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#27ae60"/>
          </marker>
        </defs>

        {/* Central formula */}
        <rect x="192" y="18" width="296" height="56" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x="340" y="42" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="14" fontWeight="700" fill="#7B0D0D">D/Dt = ∂/∂t + (V·∇)</text>
        <text x="340" y="63" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">material = local + convective</text>

        {/* Local box */}
        <rect x="44" y="114" width="196" height="58" rx="6" fill="#EAF3FF" stroke="#2980b9" strokeWidth="1.2"/>
        <text x="142" y="139" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="13" fontWeight="700" fill="#2980b9">∂/∂t</text>
        <text x="142" y="158" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">local (temporal) change</text>

        {/* Convective box */}
        <rect x="440" y="114" width="196" height="58" rx="6" fill="#f0fff4" stroke="#27ae60" strokeWidth="1.2"/>
        <text x="538" y="139" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="13" fontWeight="700" fill="#27ae60">(V·∇)</text>
        <text x="538" y="158" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">convective (spatial) change</text>

        {/* Connector arrows */}
        <line x1="258" y1="74" x2="188" y2="114" stroke="#2980b9" strokeWidth="1.4" markerEnd="url(#arrMDB)"/>
        <line x1="422" y1="74" x2="492" y2="114" stroke="#27ae60" strokeWidth="1.4" markerEnd="url(#arrMDG)"/>

        {/* Example notes */}
        <text x="142" y="192" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#2980b9" fontStyle="italic">unsteady pump pulsations:</text>
        <text x="142" y="205" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#2980b9" fontStyle="italic">V changes at fixed point</text>
        <text x="538" y="192" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#27ae60" fontStyle="italic">steady converging nozzle:</text>
        <text x="538" y="205" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#27ae60" fontStyle="italic">V changes along streamline</text>

        {/* Nozzle schematic */}
        <path d="M 44 236 L 200 236 L 240 244 L 440 244 L 480 236 L 636 236" fill="none" stroke="#bbb" strokeWidth="1" strokeDasharray="3 2"/>
        <path d="M 44 248 L 200 248 L 240 240 L 440 240 L 480 248 L 636 248" fill="none" stroke="#bbb" strokeWidth="1" strokeDasharray="3 2"/>
        <line x1="96"  y1="242" x2="130" y2="242" stroke="#c0392b" strokeWidth="1.4" markerEnd="url(#arrMD)" opacity="0.7"/>
        <line x1="308" y1="242" x2="356" y2="242" stroke="#c0392b" strokeWidth="2.0" markerEnd="url(#arrMD)" opacity="0.85"/>
        <line x1="540" y1="242" x2="604" y2="242" stroke="#c0392b" strokeWidth="2.8" markerEnd="url(#arrMD)"/>
      </svg>
      <div style={S.dCaption}>
        The material derivative D/Dt tracks change following a fluid parcel. A steady converging nozzle (bottom) shows pure convective
        acceleration — ∂/∂t = 0 but velocity still increases along the flow direction. Both terms are present in general unsteady, non-uniform flows.
      </div>
    </div>
  );
}

// ── Diagram 4: Stream Function & Velocity Potential ───────────────
function DiagramStreamFunction() {
  const W = 680, H = 278;
  const psiYs  = [44, 88, 132, 176, 220, 264];
  const phiXs  = [110, 190, 270, 350, 430, 510, 590];
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Stream Function ψ &amp; Velocity Potential φ — Orthogonal Flow Net</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrSF" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9" opacity="0.8"/>
          </marker>
        </defs>

        {/* Background */}
        <rect x="60" y="28" width="560" height="238" rx="6" fill="#f8fbff" stroke="#dde" strokeWidth="0.5"/>

        {/* Streamlines ψ = const — blue horizontal */}
        {psiYs.map(y => (
          <g key={y}>
            <line x1="60" y1={y} x2="620" y2={y} stroke="#2980b9" strokeWidth="1.4" opacity="0.50"/>
            <line x1="356" y1={y} x2="388" y2={y} stroke="#2980b9" strokeWidth="1.4" markerEnd="url(#arrSF)" opacity="0.75"/>
          </g>
        ))}

        {/* Equipotentials φ = const — red dashed vertical */}
        {phiXs.map(x => (
          <line key={x} x1={x} y1="28" x2={x} y2="266"
            stroke="#c0392b" strokeWidth="1.2" strokeDasharray="5 4" opacity="0.45"/>
        ))}

        {/* Right-angle marks at intersections */}
        {[190,350,510].map(x =>
          [88,176].map(y => (
            <path key={`${x}-${y}`}
              d={`M ${x} ${y-9} L ${x+9} ${y-9} L ${x+9} ${y}`}
              fill="none" stroke="#aaa" strokeWidth="0.9" opacity="0.8"/>
          ))
        )}

        {/* Velocity vector at one point */}
        <circle cx="350" cy="132" r="4" fill="#7B0D0D"/>
        <line x1="350" y1="132" x2="392" y2="112" stroke="#7B0D0D" strokeWidth="2" markerEnd="url(#arrSF)"/>
        <text x="398" y="110" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#7B0D0D">V</text>

        {/* Labels */}
        <text x="72" y="44" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#2980b9">ψ = const</text>
        <text x="72" y="58" fontFamily="Georgia,serif" fontSize="11" fill="#2980b9" fontStyle="italic">u = ∂ψ/∂y,  v = −∂ψ/∂x</text>
        <text x="430" y="44" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#c0392b">φ = const</text>
        <text x="430" y="58" fontFamily="Georgia,serif" fontSize="11" fill="#c0392b" fontStyle="italic">u = ∂φ/∂x,  v = ∂φ/∂y</text>

        {/* Laplace formula */}
        <rect x="222" y="240" width="236" height="26" rx="4" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="340" y="258" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#7B0D0D">∇²ψ = 0   and   ∇²φ = 0</text>
      </svg>
      <div style={S.dCaption}>
        In irrotational incompressible flow, streamlines (ψ = const, blue) and equipotential lines (φ = const, red dashed) form a
        mutually perpendicular flow net. The velocity vector V is tangent to streamlines and normal to equipotentials.
        Both ψ and φ satisfy Laplace's equation — enabling superposition of elementary solutions.
      </div>
    </div>
  );
}

// ── Diagram 5: Vorticity — Rotational vs Irrotational ─────────────
function DiagramVorticity() {
  const W = 680, H = 268;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Vorticity — Rotational vs Irrotational Flow</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrVR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrVB" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
        </defs>

        {/* === Rotational — forced vortex (left) === */}
        <rect x="28" y="28" width="290" height="222" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.2"/>
        <text x="173" y="52" textAnchor="middle" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#7B0D0D">Rotational  (ζ ≠ 0)</text>
        <text x="173" y="68" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#555">forced vortex: V = ω r</text>

        {/* Concentric circles */}
        {[28,52,76].map(rr => (
          <circle key={rr} cx="173" cy="156" r={rr} fill="none"
            stroke="#c0392b" strokeWidth="1.2" strokeDasharray="4 3" opacity="0.55"/>
        ))}
        {/* Tangential velocity arrows — proportional to r */}
        <line x1="173" y1="128" x2="200" y2="124" stroke="#c0392b" strokeWidth="1.4" markerEnd="url(#arrVR)"/>
        <line x1="173" y1="104" x2="212" y2="98"  stroke="#c0392b" strokeWidth="1.8" markerEnd="url(#arrVR)"/>
        <line x1="173" y1="80"  x2="228" y2="72"  stroke="#c0392b" strokeWidth="2.2" markerEnd="url(#arrVR)"/>

        {/* Spinning fluid element */}
        <rect x="158" y="142" width="20" height="20" rx="2"
          fill="#FEF0F0" stroke="#7B0D0D" strokeWidth="1.2"
          transform="rotate(22,168,152)"/>
        {/* Spin arc */}
        <path d="M 182 146 C 190 138 186 128 176 128"
          fill="none" stroke="#7B0D0D" strokeWidth="1.4" markerEnd="url(#arrVR)"/>

        <text x="173" y="216" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fill="#7B0D0D">ζ = ∇ × V ≠ 0</text>
        <text x="173" y="234" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">element rotates as it moves</text>

        {/* === Irrotational — free vortex (right) === */}
        <rect x="362" y="28" width="290" height="222" rx="8" fill="#EAF3FF" stroke="#2980b9" strokeWidth="1.2"/>
        <text x="507" y="52" textAnchor="middle" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#2980b9">Irrotational  (ζ = 0)</text>
        <text x="507" y="68" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#555">free vortex: V = Γ/(2πr)</text>

        {[28,52,76].map(rr => (
          <circle key={rr} cx="507" cy="156" r={rr} fill="none"
            stroke="#2980b9" strokeWidth="1.2" strokeDasharray="4 3" opacity="0.55"/>
        ))}
        {/* Velocity arrows — faster near centre */}
        <line x1="507" y1="128" x2="536" y2="120" stroke="#2980b9" strokeWidth="2.2" markerEnd="url(#arrVB)"/>
        <line x1="507" y1="104" x2="542" y2="99"  stroke="#2980b9" strokeWidth="1.7" markerEnd="url(#arrVB)"/>
        <line x1="507" y1="80"  x2="548" y2="77"  stroke="#2980b9" strokeWidth="1.3" markerEnd="url(#arrVB)"/>

        {/* Fluid element — does NOT spin */}
        <rect x="492" y="142" width="20" height="20" rx="2"
          fill="#EAF3FF" stroke="#2980b9" strokeWidth="1.2"/>

        <text x="507" y="216" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fill="#2980b9">ζ = ∇ × V = 0</text>
        <text x="507" y="234" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">element translates, no spin</text>
      </svg>
      <div style={S.dCaption}>
        Left — forced vortex (solid-body rotation): every fluid element both translates and spins on its own axis; vorticity ζ = 2ω ≠ 0.
        Right — free vortex (potential vortex): element translates and deforms but does not spin; ζ = 0 everywhere except the singular core.
        Only irrotational flows admit a velocity potential φ.
      </div>
    </div>
  );
}

// ── Diagram 6: Continuity — converging pipe ───────────────────────
function DiagramContinuity() {
  const W = 680, H = 258;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Continuity Equation — Conservation of Mass Through a Converging Pipe</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrCB" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrCR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrCG" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#27ae60"/>
          </marker>
          <marker id="arrCGr" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto">
            <polygon points="6 0, 0 3.5, 6 7" fill="#27ae60"/>
          </marker>
        </defs>

        {/* Pipe walls */}
        <path d="M 48 76 L 248 76 L 350 106 L 636 106" fill="none" stroke="#7B0D0D" strokeWidth="2.5" strokeLinecap="round"/>
        <path d="M 48 182 L 248 182 L 350 152 L 636 152" fill="none" stroke="#7B0D0D" strokeWidth="2.5" strokeLinecap="round"/>

        {/* Fluid fill */}
        <path d="M 48 76 L 248 76 L 350 106 L 636 106 L 636 152 L 350 152 L 248 182 L 48 182 Z"
          fill="#2980b9" opacity="0.10"/>

        {/* Section lines */}
        <line x1="48"  y1="68"  x2="48"  y2="190" stroke="#555" strokeWidth="1" strokeDasharray="3 2"/>
        <line x1="636" y1="98"  x2="636" y2="160" stroke="#555" strokeWidth="1" strokeDasharray="3 2"/>

        {/* Section labels */}
        <text x="48"  y="206" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">Section 1</text>
        <text x="636" y="174" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">Section 2</text>

        {/* Inlet velocity arrows */}
        <line x1="60" y1="108" x2="108" y2="108" stroke="#2980b9" strokeWidth="2.0" markerEnd="url(#arrCB)"/>
        <line x1="60" y1="129" x2="108" y2="129" stroke="#2980b9" strokeWidth="2.0" markerEnd="url(#arrCB)"/>
        <line x1="60" y1="150" x2="108" y2="150" stroke="#2980b9" strokeWidth="2.0" markerEnd="url(#arrCB)"/>
        <text x="48" y="92" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#2980b9">V₁, A₁</text>

        {/* Outlet velocity arrows — longer */}
        <line x1="540" y1="118" x2="620" y2="118" stroke="#c0392b" strokeWidth="2.6" markerEnd="url(#arrCR)"/>
        <line x1="540" y1="129" x2="620" y2="129" stroke="#c0392b" strokeWidth="2.6" markerEnd="url(#arrCR)"/>
        <line x1="540" y1="140" x2="620" y2="140" stroke="#c0392b" strokeWidth="2.6" markerEnd="url(#arrCR)"/>
        <text x="636" y="92" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#c0392b">V₂, A₂</text>

        {/* Area braces */}
        <line x1="32" y1="76"  x2="32" y2="182" stroke="#27ae60" strokeWidth="1"
          markerEnd="url(#arrCG)" markerStart="url(#arrCGr)"/>
        <text x="20" y="132" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#27ae60">A₁</text>
        <line x1="652" y1="106" x2="652" y2="152" stroke="#27ae60" strokeWidth="1"
          markerEnd="url(#arrCG)" markerStart="url(#arrCGr)"/>
        <text x="666" y="132" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#27ae60">A₂</text>

        {/* A₂ < A₁ label */}
        <text x="340" y="88" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11"
          fill="#7B0D0D" fontStyle="italic">A₂ &lt; A₁  →  V₂ &gt; V₁</text>

        {/* Formula box */}
        <rect x="210" y="192" width="260" height="52" rx="6" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.2"/>
        <text x="340" y="214" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="13" fontWeight="700" fill="#7B0D0D">ρ₁A₁V₁ = ρ₂A₂V₂</text>
        <text x="340" y="232" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">incompressible:  A₁V₁ = A₂V₂ = Q</text>
      </svg>
      <div style={S.dCaption}>
        Mass is conserved: mass flow rate ṁ = ρAV is constant along a streamtube. For incompressible flow, Q = AV is constant.
        Halving the cross-sectional area doubles the velocity — the operating principle of venturi meters, carburettors, and physiological flow in narrowed arteries.
      </div>
    </div>
  );
}

// ── Main export ───────────────────────────────────────────────────
export default function FluidKinematics() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Fluid Kinematics</h1>
      <p style={S.p}>
        Fluid kinematics describes the motion of fluids without reference to the forces that cause it.
        It provides the mathematical tools — velocity fields, streamlines, the material derivative, and
        the continuity equation — that form the language of all subsequent fluid dynamics analysis.
      </p>

      <InfoBox title="CORE CONCEPTS OVERVIEW" items={[
        "Flow classification — steady/unsteady, laminar/turbulent, compressible/incompressible, rotational/irrotational",
        "Flow description — Eulerian (fixed points) vs Lagrangian (following particles) frameworks",
        "Flow visualisation — streamlines, pathlines, streaklines; all coincide in steady flow",
        "Material derivative D/Dt — rate of change following a fluid parcel; local + convective terms",
        "Stream function ψ and velocity potential φ — scalar fields encoding 2-D incompressible/irrotational flow",
        "Vorticity ζ = ∇×V — measure of local rotation; zero in irrotational flow",
        "Continuity equation — conservation of mass: ∇·V = 0 for incompressible flow",
      ]}/>

      {/* ── Flow Classification ── */}
      <h2 style={S.h2}>Flow Classification</h2>
      <p style={S.p}>
        Every flow analysis begins by classifying the flow. Each classification eliminates terms from the
        governing equations and identifies the appropriate solution method.
      </p>
      <Table2 rows={[
        ["Steady vs unsteady",
`Steady: ∂( )/∂t = 0 — all properties constant at each fixed point
Unsteady: properties change with time at fixed locations
Quasi-steady: slowly varying; treated as steady at each instant`],
        ["Uniform vs non-uniform",
`Uniform: velocity the same at every cross-section (∂V/∂s = 0 along streamline)
Non-uniform: velocity varies with position along the flow
Fully-developed pipe flow is uniform; entry regions and bends are non-uniform`],
        ["Laminar vs turbulent",
`Laminar (Re < 2300 in pipes): smooth layered flow; viscosity dominates
Turbulent (Re > 4000): chaotic, mixing eddies; inertia dominates
Transition zone 2300 < Re < 4000: sensitive to disturbances and surface roughness`],
        ["Compressible vs incompressible",
`Incompressible: ρ = const; valid for liquids and gases with Ma < 0.3
Compressible: ρ varies with P; essential for high-speed gas flows (Ma > 0.3)
Mach number criterion: Ma = V/c;  c = √(γRT) for ideal gas`],
        ["Rotational vs irrotational",
`Irrotational: ∇×V = 0 everywhere; admits velocity potential φ
Rotational: ∇×V ≠ 0; includes viscous boundary layers and turbulence
Potential flow theory assumes irrotational, inviscid, incompressible flow`],
        ["1-D, 2-D, 3-D flow",
`1-D: properties vary along one coordinate (pipe flow, most duct flows)
2-D: properties vary in two directions (flow over infinite wing section)
3-D: full spatial variation; most real engineering flows require CFD`],
      ]}/>

      {/* ── Eulerian vs Lagrangian ── */}
      <h2 style={S.h2}>Eulerian &amp; Lagrangian Descriptions</h2>
      <p style={S.p}>
        There are two fundamental ways to describe fluid motion mathematically. The choice determines
        which equations are used and how boundary conditions are applied.
      </p>
      <DiagramEulerLagrange/>
      <Table2 rows={[
        ["Eulerian description",
`Properties expressed as fields: V = V(x,y,z,t),  P = P(x,y,z,t)
Observer fixed in space; fluid flows past
Standard approach — naturally suits fixed control volumes and sensors`],
        ["Lagrangian description",
`Properties follow a tagged parcel: V = V(x₀,y₀,z₀,t)
(x₀,y₀,z₀) = initial position labels the parcel
Used in oceanography (drifter buoys), spray/droplet tracking, particle methods`],
        ["Connection — material derivative",
`Any Lagrangian rate = Eulerian material derivative:
D( )/Dt = ∂( )/∂t + (V·∇)( )
Converts Newton's 2nd law (Lagrangian) to Navier-Stokes (Eulerian)`],
      ]}/>

      {/* ── Streamlines, Pathlines & Streaklines ── */}
      <h2 style={S.h2}>Streamlines, Pathlines &amp; Streaklines</h2>
      <p style={S.p}>
        Three distinct line types visualise fluid motion. In steady flow all three coincide — which is
        why smoke-wire photographs in a wind tunnel directly reveal streamlines.
      </p>
      <DiagramFlowLines/>
      <Table2 rows={[
        ["Streamlines",
`Lines everywhere tangent to the instantaneous velocity vector field
Equation: dx/u = dy/v = dz/w  (at fixed time t)
Cannot cross (velocity unique at each point in space at any instant)
Spacing inversely proportional to speed: closer → faster`],
        ["Pathlines",
`Trajectory of a single fluid particle tracked over time
Found by integrating: dx/dt = u(x,t), dy/dt = v(x,t), dz/dt = w(x,t)
Lagrangian concept; differs from streamlines in unsteady flow`],
        ["Streaklines",
`Instantaneous locus of all particles that passed through a fixed point
What dye injection, smoke wires, and hydrogen-bubble wires reveal
In unsteady flow, differs from both streamlines and pathlines`],
        ["Steady flow — all three coincide",
`When ∂V/∂t = 0: streamlines ≡ pathlines ≡ streaklines
Justifies using dye/smoke for streamline visualisation in wind tunnels
Unsteady flow: the three line types are generally different`],
        ["Streamtubes",
`Bundle of streamlines passing through a closed curve
No fluid crosses the streamtube wall (tangential velocity)
Continuity and Bernoulli equations applied along a streamtube`],
      ]}/>

      {/* ── Material Derivative ── */}
      <h2 style={S.h2}>The Material Derivative</h2>
      <p style={S.p}>
        The material (substantial) derivative D/Dt gives the rate of change of any property following
        a fluid parcel as it moves. It appears in every conservation law of fluid mechanics, converting
        Lagrangian physics into Eulerian governing equations.
      </p>
      <DiagramMaterialDerivative/>
      <Table2 rows={[
        ["Material derivative",
`D/Dt = ∂/∂t + u∂/∂x + v∂/∂y + w∂/∂z = ∂/∂t + (V·∇)
Applies to scalars (T, P, ρ) and vectors (V)
DV/Dt = fluid particle acceleration → appears in Newton's 2nd law`],
        ["Local term ∂/∂t",
`Rate of change at a fixed point due to flow unsteadiness
Zero for steady flow; non-zero for oscillating, pulsating, or starting flows
Example: pressure oscillations from a reciprocating pump`],
        ["Convective term (V·∇)",
`Rate of change as the parcel moves through a spatially varying field
Present even in perfectly steady flow
Example: fluid accelerating through a convergent nozzle (∂V/∂t = 0)`],
        ["Fluid acceleration a",
`a = DV/Dt = ∂V/∂t + (V·∇)V
Tangential component: V(∂V/∂s) — speed change along streamline
Normal component: V²/R — centripetal acceleration toward centre of curvature`],
      ]}/>

      {/* ── Stream Function & Velocity Potential ── */}
      <h2 style={S.h2}>Stream Function &amp; Velocity Potential</h2>
      <p style={S.p}>
        For two-dimensional incompressible flow the velocity field can be encoded in a single scalar —
        the stream function ψ. For irrotational flow an additional scalar — the velocity potential φ —
        also exists. Their level curves form the orthogonal flow net.
      </p>
      <DiagramStreamFunction/>
      <Table2 rows={[
        ["Stream function ψ",
`u = ∂ψ/∂y,  v = −∂ψ/∂x   [m²/s per unit depth in 2-D]
Lines ψ = const are streamlines (by construction)
Flow rate between two streamlines: Q = ψ₂ − ψ₁
Automatically satisfies ∇·V = 0 (continuity)`],
        ["Velocity potential φ",
`Exists only if ∇×V = 0 (irrotational flow)
u = ∂φ/∂x,  v = ∂φ/∂y   (or V = ∇φ in 3-D)
Lines φ = const are equipotentials — always ⊥ to streamlines
Satisfies Laplace's equation ∇²φ = 0`],
        ["Elementary potential flows",
`Uniform flow:  φ = U∞x,  ψ = U∞y
Source/Sink:   φ = (Q/2π) ln r,  ψ = (Q/2π)θ
Free vortex:   φ = (Γ/2π)θ,  ψ = −(Γ/2π) ln r
Doublet:       φ = (κ cosθ)/(2πr)
Superpose solutions — linearity of ∇²φ = 0 permits arbitrary combinations`],
        ["Circulation Γ",
`Γ = ∮_C V·ds  (line integral around closed curve C)
For irrotational flow:  Γ = 0  (no vortex inside C)
Kutta–Joukowski lift: L = ρ V∞ Γ  per unit span`],
        ["Flow net",
`Orthogonal grid of ψ and φ lines used to visualise and solve potential flows
Velocity: V ≈ Δφ/Δs  (Δs = spacing between equipotentials along streamline)
Equal Δψ intervals carry equal flow; square cells indicate local velocity`],
      ]}/>

      {/* ── Vorticity ── */}
      <h2 style={S.h2}>Vorticity &amp; Rotation</h2>
      <p style={S.p}>
        Vorticity quantifies the local spinning motion of fluid elements. It equals twice the angular
        velocity of a fluid parcel and determines whether the simplifying potential-flow framework applies.
      </p>
      <DiagramVorticity/>
      <Table2 rows={[
        ["Vorticity vector ζ",
`ζ = ∇ × V   [s⁻¹]
In 2-D:  ζ_z = ∂v/∂x − ∂u/∂y
ζ = 2ω  where ω is the angular velocity of a fluid element`],
        ["Forced vortex (rotational)",
`Solid-body rotation: V_θ = ω r
ζ = 2ω = constant throughout (non-zero)
Like water in a spinning bucket; free surface is a paraboloid`],
        ["Free vortex (irrotational)",
`V_θ = Γ/(2πr) — velocity increases toward centre
ζ = 0 everywhere except singular vortex core at r = 0
Like bath-plug vortex away from the drain; angular momentum rV_θ = const`],
        ["Kelvin's circulation theorem",
`DΓ/Dt = 0 for inviscid, barotropic flow with conservative body forces
Vorticity is conserved following fluid parcels in ideal flow
Explains persistence of aircraft trailing vortices and atmospheric vortices`],
        ["Vortex stretching",
`Stretching a vortex tube narrows its cross-section and intensifies ω
Angular momentum conservation: ω × A = const
Key mechanism in the 3-D turbulence energy cascade toward small scales`],
      ]}/>

      {/* ── Continuity ── */}
      <h2 style={S.h2}>The Continuity Equation</h2>
      <p style={S.p}>
        The continuity equation is the mathematical statement of mass conservation applied to a fluid.
        It must be satisfied by every physically realisable flow and is the first equation checked when
        verifying a velocity field.
      </p>
      <DiagramContinuity/>
      <Table2 rows={[
        ["Integral (control volume) form",
`∂/∂t ∫∫∫_CV ρ dV + ∮∮_CS ρ(V·n̂) dA = 0
Rate of mass increase inside CV + net mass efflux through CS = 0
Basis for analysing pumps, turbines, nozzles, pipe junctions`],
        ["Differential form — general",
`∂ρ/∂t + ∇·(ρV) = 0
Equivalent: Dρ/Dt + ρ(∇·V) = 0
Applies pointwise throughout the flow field`],
        ["Incompressible (∇·V = 0)",
`∂u/∂x + ∂v/∂y + ∂w/∂z = 0
Density constant (not varying in space or time)
Valid for liquids and low-speed gases (Ma < 0.3)`],
        ["Steady 1-D pipe flow",
`ρ₁A₁V₁ = ρ₂A₂V₂ = ṁ  (mass flow rate, kg/s)
Incompressible:  A₁V₁ = A₂V₂ = Q  (volumetric flow rate, m³/s)
Smaller area → higher velocity (nozzles, venturi, arterial stenosis)`],
        ["Reynolds Transport Theorem",
`dB_sys/dt = ∂/∂t ∫∫∫_CV ρb dV + ∮∮_CS ρb(V·n̂) dA
b = B per unit mass (b=1 → continuity; b=V → linear momentum)
Converts any system (Lagrangian) conservation law to CV (Eulerian) form`],
      ]}/>

      {/* ── Summary ── */}
      <h2 style={S.h2}>Key Formulae Summary</h2>
      <InfoBox title="FLUID KINEMATICS — QUICK REFERENCE" items={[
        "Material derivative:            D/Dt = ∂/∂t + u∂/∂x + v∂/∂y + w∂/∂z",
        "Fluid acceleration:             a = DV/Dt = ∂V/∂t + (V·∇)V",
        "Streamline equation:            dx/u = dy/v = dz/w",
        "Stream function (2-D incomp.):  u = ∂ψ/∂y,   v = −∂ψ/∂x",
        "Velocity potential:             u = ∂φ/∂x,   v = ∂φ/∂y   (irrotational only)",
        "Laplace equation:               ∇²φ = 0   and   ∇²ψ = 0",
        "Vorticity:                      ζ = ∇×V;   in 2-D: ζ_z = ∂v/∂x − ∂u/∂y",
        "Circulation:                    Γ = ∮ V·ds",
        "Continuity (incompressible):    ∇·V = 0   →   ∂u/∂x + ∂v/∂y + ∂w/∂z = 0",
        "Steady 1-D continuity:          ρ₁A₁V₁ = ρ₂A₂V₂;   incompressible: A₁V₁ = A₂V₂",
        "Reynolds Transport Theorem:     dB/dt = ∂/∂t ∫ρb dV + ∮ρb(V·n̂) dA",
      ]}/>
    </div>
  );
}